// extracted by mini-css-extract-plugin
module.exports = {"play":"page_play__EpBLO","title":"page_title__86ESz","description":"page_description__MJoB7","smallImage":"page_smallImage__OMCL8"};